module.exports = __webpack_public_path__ + "img/register.e3f20a19.svg";